import { createElement, useCallback } from 'react';
import {
    type Dialog,
    type DialogBaseProps,
    DialogComponent,
    type DialogId,
    activeDialogsSelector,
    hideDialog,
} from '@lingoda/dialogs';
import { useDispatch, useSelector } from '@lingoda/hooks';
import { Box, Suspense } from '@lingoda/ui';
import { dialogsMap } from './dialogsMap';

const IgnoredDialogs: DialogComponent[] = [
    DialogComponent.MobileBookingDialog,
    DialogComponent.MobilePreClassChecklistDialog,
    DialogComponent.MobileCreditsPurchaseDialog,
    DialogComponent.MobileModuleSelectDialog,
    DialogComponent.MobileVocabularyDialog,
];

export const DialogsManager = () => {
    const dispatch = useDispatch();
    const dialogs = useSelector(activeDialogsSelector);

    const handleHideDialog = useCallback(
        (id: DialogId) => () => {
            dispatch(hideDialog(id));
        },
        [dispatch],
    );

    if (!dialogs) {
        return null;
    }

    return (
        <Suspense variant="linear">
            <Box>
                {dialogs.map((dialog: Dialog, index) => {
                    if (IgnoredDialogs.includes(dialog.component)) {
                        return null;
                    }

                    return createElement(
                        dialogsMap[dialog.component] as React.FC<
                            typeof dialog.params & DialogBaseProps
                        >,
                        {
                            ...dialog.params,
                            key: dialog.id,
                            dialogId: dialog.id,
                            hideDialog: handleHideDialog(dialog.id),
                            hideBackdrop: index > 0,
                        },
                    );
                })}
            </Box>
        </Suspense>
    );
};
